import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqs = [
  { q: 'home.faq.q1', a: 'home.faq.a1' },
  { q: 'home.faq.q2', a: 'home.faq.a2' },
  { q: 'home.faq.q3', a: 'home.faq.a3' },
  { q: 'home.faq.q4', a: 'home.faq.a4' },
  { q: 'home.faq.q5', a: 'home.faq.a5' },
  { q: 'home.faq.q6', a: 'home.faq.a6' },
  { q: 'home.faq.q7', a: 'home.faq.a7' },
  { q: 'home.faq.q8', a: 'home.faq.a8' },
];

export default function Faq() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: t(f.q),
      acceptedAnswer: { '@type': 'Answer', text: t(f.a) },
    })),
  };

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />

        <div className="flex flex-col items-center text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{t('home.faqTitle')}</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('home.faqSub')}</p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{t(f.q)}</span>
                  <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center text-foreground-500">
                    <i className={`text-lg ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{t(f.a)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}